import { ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      {/* Mobile Sticky WhatsApp CTA */}
      <a
        href="https://wa.me/2250757006969?text=Bonjour%20KD'S%20BEAUTY%20!%20Je%20souhaite%20prendre%20rendez-vous."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 z-40 md:hidden w-14 h-14 flex items-center justify-center rounded-full bg-green-600 text-white shadow-lg hover:bg-green-700 transition-colors animate-bounce"
        aria-label="Réserver par WhatsApp"
        style={{ animationDuration: '3s' }}
      >
        <i className="ri-whatsapp-line text-2xl" />
      </a>
    </div>
  );
}